import { useI18n } from '@i18n';
import { IconButton, Tooltip } from '@mui/material';
import { IMAGES } from '@/assets';

type Props = {
  onToggleCollapse: VoidFunction;
  collapseHover: boolean;
};

export function CollapseButton({ onToggleCollapse, collapseHover }: Props) {
  const { t } = useI18n();

  return (
    <Tooltip title={!collapseHover ? t('General_CollapseSidebar') : t('General_LockSidebar')} placement="right">
      <IconButton
        onClick={onToggleCollapse}
        className="collapse-button"
        sx={{
          transition: (theme) =>
            theme.transitions.create('opacity', {
              duration: theme.transitions.duration.shorter,
            }),
          // when sidebar get hovered, opacity goes to 100
          opacity: 0,
        }}
      >
        <img src={IMAGES.CollapseIcon} width={24} height={24} alt="" />
      </IconButton>
    </Tooltip>
  );
}
